//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SHIFT_API_BASE_URL = new InjectionToken<string>('SHIFT_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ShiftApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SHIFT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftUpdate(body?: UpdateShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftDelete(body?: DeleteShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftPatch(body?: PartialUpdateShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftPatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftAdjust(body?: AdjustShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/adjust";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftAdjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftAdjust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftAdjust(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftApprove(body?: ApproveShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftApprove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyShift(body?: CopyShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/copyforward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCopyShift(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ResponseModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftDeny(body?: DenyShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/deny";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftDeny(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftDeny(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftDeny(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetDocumentByUri(body?: GetDocumentByUriCommand | undefined): Observable<Stream> {
        let url_ = this.baseUrl + "/shift/document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetDocumentByUri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetDocumentByUri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Stream>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Stream>;
        }));
    }

    protected processShiftGetDocumentByUri(response: HttpResponseBase): Observable<Stream> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stream.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEvvCompliance(body?: EvvComplianceRequest | undefined): Observable<EvvComplianceResult[]> {
        let url_ = this.baseUrl + "/shift/evv/compliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvvCompliance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvvCompliance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvvComplianceResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvvComplianceResult[]>;
        }));
    }

    protected processGetEvvCompliance(response: HttpResponseBase): Observable<EvvComplianceResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvvComplianceResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGet(body?: FetchShiftCommand | undefined): Observable<ShiftFilterResponse[]> {
        let url_ = this.baseUrl + "/shift/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftFilterResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftFilterResponse[]>;
        }));
    }

    protected processShiftGet(response: HttpResponseBase): Observable<ShiftFilterResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftFilterResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftFreeSave(body?: FreeSaveShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/freesave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftFreeSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftFreeSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftFreeSave(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAndnMarkTimeSheetEntry(body?: TimesheetEntriesRequest | undefined): Observable<TimesheetEntriesResponse> {
        let url_ = this.baseUrl + "/shift/getandmarktimesheetentry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndnMarkTimeSheetEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndnMarkTimeSheetEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetEntriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetEntriesResponse>;
        }));
    }

    protected processGetAndnMarkTimeSheetEntry(response: HttpResponseBase): Observable<TimesheetEntriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetEntriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTimesheetEntriesForBatching(body?: TimesheetEntriesRequest | undefined): Observable<TimesheetEntriesResponse> {
        let url_ = this.baseUrl + "/shift/gettimesheetentriesforbatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetEntriesForBatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetEntriesForBatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetEntriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetEntriesResponse>;
        }));
    }

    protected processGetTimesheetEntriesForBatching(response: HttpResponseBase): Observable<TimesheetEntriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetEntriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetHistory(body?: GetShiftHistoryCommand | undefined): Observable<ShiftHistoryResponse[]> {
        let url_ = this.baseUrl + "/shift/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftHistoryResponse[]>;
        }));
    }

    protected processShiftGetHistory(response: HttpResponseBase): Observable<ShiftHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftHistoryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetApprovalHistory(body?: GetShiftApprovalHistoryCommand | undefined): Observable<ChangedShiftProperty[]> {
        let url_ = this.baseUrl + "/shift/history/approval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetApprovalHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetApprovalHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangedShiftProperty[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangedShiftProperty[]>;
        }));
    }

    protected processShiftGetApprovalHistory(response: HttpResponseBase): Observable<ChangedShiftProperty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangedShiftProperty.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetHistoryDetails(body?: GetShiftHistoryDetailsCommand | undefined): Observable<ShiftHistoryDetailsResponse[]> {
        let url_ = this.baseUrl + "/shift/history/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetHistoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetHistoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftHistoryDetailsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftHistoryDetailsResponse[]>;
        }));
    }

    protected processShiftGetHistoryDetails(response: HttpResponseBase): Observable<ShiftHistoryDetailsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftHistoryDetailsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetEvvHistory(body?: GetShiftEvvHistoryRequest | undefined): Observable<EditedEvvShiftProperties> {
        let url_ = this.baseUrl + "/shift/history/evv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetEvvHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetEvvHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditedEvvShiftProperties>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditedEvvShiftProperties>;
        }));
    }

    protected processShiftGetEvvHistory(response: HttpResponseBase): Observable<EditedEvvShiftProperties> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditedEvvShiftProperties.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftGetEvvHistoryDetails(body?: GetShiftEvvHistoryDetailsCommand | undefined): Observable<EditedEvvShiftPropertiesWithMetadata[]> {
        let url_ = this.baseUrl + "/shift/history/evv/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftGetEvvHistoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftGetEvvHistoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditedEvvShiftPropertiesWithMetadata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditedEvvShiftPropertiesWithMetadata[]>;
        }));
    }

    protected processShiftGetEvvHistoryDetails(response: HttpResponseBase): Observable<EditedEvvShiftPropertiesWithMetadata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditedEvvShiftPropertiesWithMetadata.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftNeverToBePaid(body?: NeverToBePaidShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/nevertobepaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftNeverToBePaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftNeverToBePaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftNeverToBePaid(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftReadyToBePaid(body?: ReadyToBePaidShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/readytobepaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftReadyToBePaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftReadyToBePaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftReadyToBePaid(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftReject(body?: RejectShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftReject(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftRemovalInProgress(body?: RemovalInProgressShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/removalinprogress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftRemovalInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftRemovalInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftRemovalInProgress(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftRemove(body?: RemoveShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftRemove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftResubmit(body?: ResubmitShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/resubmit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftResubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftResubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftResubmit(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftSave(body?: SaveShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftSave(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftSubmit(body?: SubmitShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftSubmit(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shiftRequests (optional) 
     * @param intent (optional) 
     * @param commandIdentifier (optional) 
     * @param outboxMessageId (optional) 
     * @return Success
     */
    shiftSubmitWithLines(shiftRequests?: ShiftRequest[] | undefined, intent?: string | undefined, commandIdentifier?: string | undefined, outboxMessageId?: number | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/submit-with-lines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (shiftRequests === null || shiftRequests === undefined)
            throw new globalThis.Error("The parameter 'shiftRequests' cannot be null.");
        else
            shiftRequests.forEach(item_ => content_.append("ShiftRequests", item_.toString()));
        if (intent === null || intent === undefined)
            throw new globalThis.Error("The parameter 'intent' cannot be null.");
        else
            content_.append("Intent", intent.toString());
        if (commandIdentifier === null || commandIdentifier === undefined)
            throw new globalThis.Error("The parameter 'commandIdentifier' cannot be null.");
        else
            content_.append("CommandIdentifier", commandIdentifier.toString());
        if (outboxMessageId === null || outboxMessageId === undefined)
            throw new globalThis.Error("The parameter 'outboxMessageId' cannot be null.");
        else
            content_.append("OutboxMessageId", outboxMessageId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftSubmitWithLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftSubmitWithLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftSubmitWithLines(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftSuspend(body?: SuspendShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/suspend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftSuspend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftSuspend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftSuspend(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimesheetEntryStatus(body?: TimesheetEntriesRequest | undefined): Observable<TimesheetEntriesResponse> {
        let url_ = this.baseUrl + "/shift/UpdateTimesheetEntryStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimesheetEntryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimesheetEntryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetEntriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetEntriesResponse>;
        }));
    }

    protected processUpdateTimesheetEntryStatus(response: HttpResponseBase): Observable<TimesheetEntriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetEntriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftAdjustV1(body?: AdjustShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/v1/adjust";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftAdjustV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftAdjustV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftAdjustV1(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftRemovalInProgressV1(body?: RemovalInProgressShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/v1/removalinprogress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftRemovalInProgressV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftRemovalInProgressV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftRemovalInProgressV1(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftRevertToReadyToBePaidV1(body?: RevertToReadyToBePaidV1ShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/v1/reverttoreadytobepaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftRevertToReadyToBePaidV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftRevertToReadyToBePaidV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftRevertToReadyToBePaidV1(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftVoidV1(body?: VoidShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/v1/void";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftVoidV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftVoidV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftVoidV1(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftV2Get(body?: FetchShiftV2Command | undefined): Observable<ShiftFilterResponse[]> {
        let url_ = this.baseUrl + "/shift/v2/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftV2Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftV2Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftFilterResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftFilterResponse[]>;
        }));
    }

    protected processShiftV2Get(response: HttpResponseBase): Observable<ShiftFilterResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftFilterResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shiftVoid(body?: VoidShiftCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/shift/void";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShiftVoid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShiftVoid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processShiftVoid(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum Action {
    None = "None",
    Success = "Success",
    Created = "Created",
    Accepted = "Accepted",
    Updated = "Updated",
    Deleted = "Deleted",
}

export class Address implements IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class AdjustShiftCommand implements IAdjustShiftCommand {
    readonly shiftRequests?: AdjustShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IAdjustShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(AdjustShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): AdjustShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IAdjustShiftCommand {
    shiftRequests?: AdjustShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class AdjustShiftRequest implements IAdjustShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    docTypeEnum?: DocType;
    adjustmentType?: number;
    adjustmentsEnum?: AdjustmentsEnum;
    inTime?: string | undefined;
    outTime?: string | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billUnits?: number | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    serviceCode?: string | undefined;
    acn?: string | undefined;
    billRateUnitMethod?: UnitMethod;
    reasonDescription?: string | undefined;

    constructor(data?: IAdjustShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.transactionId = _data["transactionId"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.caregiverId = _data["caregiverId"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.docTypeEnum = _data["docTypeEnum"];
            this.adjustmentType = _data["adjustmentType"];
            this.adjustmentsEnum = _data["adjustmentsEnum"];
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billUnits = _data["billUnits"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            this.serviceCode = _data["serviceCode"];
            this.acn = _data["acn"];
            this.billRateUnitMethod = _data["billRateUnitMethod"];
            this.reasonDescription = _data["reasonDescription"];
        }
    }

    static fromJS(data: any): AdjustShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["transactionId"] = this.transactionId;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["caregiverId"] = this.caregiverId;
        data["isSkipValidation"] = this.isSkipValidation;
        data["docTypeEnum"] = this.docTypeEnum;
        data["adjustmentType"] = this.adjustmentType;
        data["adjustmentsEnum"] = this.adjustmentsEnum;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billUnits"] = this.billUnits;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["serviceCode"] = this.serviceCode;
        data["acn"] = this.acn;
        data["billRateUnitMethod"] = this.billRateUnitMethod;
        data["reasonDescription"] = this.reasonDescription;
        return data;
    }
}

export interface IAdjustShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    docTypeEnum?: DocType;
    adjustmentType?: number;
    adjustmentsEnum?: AdjustmentsEnum;
    inTime?: string | undefined;
    outTime?: string | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billUnits?: number | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    serviceCode?: string | undefined;
    acn?: string | undefined;
    billRateUnitMethod?: UnitMethod;
    reasonDescription?: string | undefined;
}

export enum AdjustmentsEnum {
    ACN = "ACN",
    BillRate = "BillRate",
    PayRate = "PayRate",
    ChangeTime = "ChangeTime",
    RemoveTime = "RemoveTime",
    ServiceCode = "ServiceCode",
    Hold = "Hold",
    Unhold = "Unhold",
    ServiceDate = "ServiceDate",
    RulesSkip = "RulesSkip",
    NeverBill = "NeverBill",
    NeverPay = "NeverPay",
    RemoveNeverBill = "RemoveNeverBill",
    RemoveNeverPay = "RemoveNeverPay",
}

export class ApproveShiftCommand implements IApproveShiftCommand {
    readonly shiftRequests?: ApproveShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IApproveShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ApproveShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): ApproveShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IApproveShiftCommand {
    shiftRequests?: ApproveShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class ApproveShiftRequest implements IApproveShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: IApproveShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): ApproveShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IApproveShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class ChangedShiftProperty implements IChangedShiftProperty {
    id?: string | undefined;
    shiftId?: string | undefined;
    propertyName?: string | undefined;
    previousValue?: any | undefined;
    currentValue?: any | undefined;
    actionType?: string | undefined;
    changedOn?: string | undefined;
    changedByEmail?: string | undefined;
    changedByUserName?: string | undefined;

    constructor(data?: IChangedShiftProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftId = _data["shiftId"];
            this.propertyName = _data["propertyName"];
            this.previousValue = _data["previousValue"];
            this.currentValue = _data["currentValue"];
            this.actionType = _data["actionType"];
            this.changedOn = _data["changedOn"];
            this.changedByEmail = _data["changedByEmail"];
            this.changedByUserName = _data["changedByUserName"];
        }
    }

    static fromJS(data: any): ChangedShiftProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ChangedShiftProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftId"] = this.shiftId;
        data["propertyName"] = this.propertyName;
        data["previousValue"] = this.previousValue;
        data["currentValue"] = this.currentValue;
        data["actionType"] = this.actionType;
        data["changedOn"] = this.changedOn;
        data["changedByEmail"] = this.changedByEmail;
        data["changedByUserName"] = this.changedByUserName;
        return data;
    }
}

export interface IChangedShiftProperty {
    id?: string | undefined;
    shiftId?: string | undefined;
    propertyName?: string | undefined;
    previousValue?: any | undefined;
    currentValue?: any | undefined;
    actionType?: string | undefined;
    changedOn?: string | undefined;
    changedByEmail?: string | undefined;
    changedByUserName?: string | undefined;
}

export class CopyShiftCommand implements ICopyShiftCommand {
    readonly shiftRequests?: CopyShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: ICopyShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(CopyShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): CopyShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface ICopyShiftCommand {
    shiftRequests?: CopyShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class CopyShiftRequest implements ICopyShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    source?: string | undefined;

    constructor(data?: ICopyShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): CopyShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["source"] = this.source;
        return data;
    }
}

export interface ICopyShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    source?: string | undefined;
}

export class DateTimeExtractedEvidenceItem implements IDateTimeExtractedEvidenceItem {
    value?: string;
    confidence?: number;

    constructor(data?: IDateTimeExtractedEvidenceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): DateTimeExtractedEvidenceItem {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeExtractedEvidenceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IDateTimeExtractedEvidenceItem {
    value?: string;
    confidence?: number;
}

export class DecimalExtractedEvidenceItem implements IDecimalExtractedEvidenceItem {
    value?: number;
    confidence?: number;

    constructor(data?: IDecimalExtractedEvidenceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): DecimalExtractedEvidenceItem {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalExtractedEvidenceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IDecimalExtractedEvidenceItem {
    value?: number;
    confidence?: number;
}

export class DeleteShiftCommand implements IDeleteShiftCommand {
    readonly shiftRequests?: DeleteShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IDeleteShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(DeleteShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): DeleteShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IDeleteShiftCommand {
    shiftRequests?: DeleteShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class DeleteShiftRequest implements IDeleteShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: IDeleteShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): DeleteShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IDeleteShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class DenyShiftCommand implements IDenyShiftCommand {
    readonly shiftRequests?: DenyShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IDenyShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(DenyShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): DenyShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DenyShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IDenyShiftCommand {
    shiftRequests?: DenyShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class DenyShiftRequest implements IDenyShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    utexData?: UtexData;

    constructor(data?: IDenyShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.utexData = _data["utexData"] ? UtexData.fromJS(_data["utexData"]) : undefined as any;
        }
    }

    static fromJS(data: any): DenyShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DenyShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["utexData"] = this.utexData ? this.utexData.toJSON() : undefined as any;
        return data;
    }
}

export interface IDenyShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    utexData?: UtexData;
}

export enum DocType {
    Enrichmentdata = "Enrichmentdata",
    Shift = "Shift",
    Mileage = "Mileage",
    Fee = "Fee",
    GHS = "GHS",
    GHA = "GHA",
    Vendor = "Vendor",
    SHA = "SHA",
    MLA = "MLA",
}

export class EditMetadata implements IEditMetadata {
    editedByUserName?: string | undefined;
    editedByUserEmail?: string | undefined;
    editedOn?: string | undefined;

    constructor(data?: IEditMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editedByUserName = _data["editedByUserName"];
            this.editedByUserEmail = _data["editedByUserEmail"];
            this.editedOn = _data["editedOn"];
        }
    }

    static fromJS(data: any): EditMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new EditMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editedByUserName"] = this.editedByUserName;
        data["editedByUserEmail"] = this.editedByUserEmail;
        data["editedOn"] = this.editedOn;
        return data;
    }
}

export interface IEditMetadata {
    editedByUserName?: string | undefined;
    editedByUserEmail?: string | undefined;
    editedOn?: string | undefined;
}

export class EditedEvvShiftProperties implements IEditedEvvShiftProperties {
    isServiceCodeEdited?: boolean;
    isTimeEdited?: boolean;
    isGpsEdited?: boolean;
    isCaregiverEdited?: boolean;
    isParticipantEdited?: boolean;
    isAdjustedFromOrigin?: boolean;

    constructor(data?: IEditedEvvShiftProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isServiceCodeEdited = _data["isServiceCodeEdited"];
            this.isTimeEdited = _data["isTimeEdited"];
            this.isGpsEdited = _data["isGpsEdited"];
            this.isCaregiverEdited = _data["isCaregiverEdited"];
            this.isParticipantEdited = _data["isParticipantEdited"];
            this.isAdjustedFromOrigin = _data["isAdjustedFromOrigin"];
        }
    }

    static fromJS(data: any): EditedEvvShiftProperties {
        data = typeof data === 'object' ? data : {};
        let result = new EditedEvvShiftProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isServiceCodeEdited"] = this.isServiceCodeEdited;
        data["isTimeEdited"] = this.isTimeEdited;
        data["isGpsEdited"] = this.isGpsEdited;
        data["isCaregiverEdited"] = this.isCaregiverEdited;
        data["isParticipantEdited"] = this.isParticipantEdited;
        data["isAdjustedFromOrigin"] = this.isAdjustedFromOrigin;
        return data;
    }
}

export interface IEditedEvvShiftProperties {
    isServiceCodeEdited?: boolean;
    isTimeEdited?: boolean;
    isGpsEdited?: boolean;
    isCaregiverEdited?: boolean;
    isParticipantEdited?: boolean;
    isAdjustedFromOrigin?: boolean;
}

export class EditedEvvShiftPropertiesWithMetadata implements IEditedEvvShiftPropertiesWithMetadata {
    isServiceCodeEdited?: boolean;
    isTimeEdited?: boolean;
    isGpsEdited?: boolean;
    isCaregiverEdited?: boolean;
    isParticipantEdited?: boolean;
    isAdjustedFromOrigin?: boolean;
    transactionId?: string | undefined;
    timeMetadata?: EditMetadata;
    serviceCodeMetadata?: EditMetadata;
    gpsMetadata?: EditMetadata;
    caregiverMetadata?: EditMetadata;
    participantMetadata?: EditMetadata;
    firstEditMetadata?: FirstEditMetadata;

    constructor(data?: IEditedEvvShiftPropertiesWithMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isServiceCodeEdited = _data["isServiceCodeEdited"];
            this.isTimeEdited = _data["isTimeEdited"];
            this.isGpsEdited = _data["isGpsEdited"];
            this.isCaregiverEdited = _data["isCaregiverEdited"];
            this.isParticipantEdited = _data["isParticipantEdited"];
            this.isAdjustedFromOrigin = _data["isAdjustedFromOrigin"];
            this.transactionId = _data["transactionId"];
            this.timeMetadata = _data["timeMetadata"] ? EditMetadata.fromJS(_data["timeMetadata"]) : undefined as any;
            this.serviceCodeMetadata = _data["serviceCodeMetadata"] ? EditMetadata.fromJS(_data["serviceCodeMetadata"]) : undefined as any;
            this.gpsMetadata = _data["gpsMetadata"] ? EditMetadata.fromJS(_data["gpsMetadata"]) : undefined as any;
            this.caregiverMetadata = _data["caregiverMetadata"] ? EditMetadata.fromJS(_data["caregiverMetadata"]) : undefined as any;
            this.participantMetadata = _data["participantMetadata"] ? EditMetadata.fromJS(_data["participantMetadata"]) : undefined as any;
            this.firstEditMetadata = _data["firstEditMetadata"] ? FirstEditMetadata.fromJS(_data["firstEditMetadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): EditedEvvShiftPropertiesWithMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new EditedEvvShiftPropertiesWithMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isServiceCodeEdited"] = this.isServiceCodeEdited;
        data["isTimeEdited"] = this.isTimeEdited;
        data["isGpsEdited"] = this.isGpsEdited;
        data["isCaregiverEdited"] = this.isCaregiverEdited;
        data["isParticipantEdited"] = this.isParticipantEdited;
        data["isAdjustedFromOrigin"] = this.isAdjustedFromOrigin;
        data["transactionId"] = this.transactionId;
        data["timeMetadata"] = this.timeMetadata ? this.timeMetadata.toJSON() : undefined as any;
        data["serviceCodeMetadata"] = this.serviceCodeMetadata ? this.serviceCodeMetadata.toJSON() : undefined as any;
        data["gpsMetadata"] = this.gpsMetadata ? this.gpsMetadata.toJSON() : undefined as any;
        data["caregiverMetadata"] = this.caregiverMetadata ? this.caregiverMetadata.toJSON() : undefined as any;
        data["participantMetadata"] = this.participantMetadata ? this.participantMetadata.toJSON() : undefined as any;
        data["firstEditMetadata"] = this.firstEditMetadata ? this.firstEditMetadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IEditedEvvShiftPropertiesWithMetadata {
    isServiceCodeEdited?: boolean;
    isTimeEdited?: boolean;
    isGpsEdited?: boolean;
    isCaregiverEdited?: boolean;
    isParticipantEdited?: boolean;
    isAdjustedFromOrigin?: boolean;
    transactionId?: string | undefined;
    timeMetadata?: EditMetadata;
    serviceCodeMetadata?: EditMetadata;
    gpsMetadata?: EditMetadata;
    caregiverMetadata?: EditMetadata;
    participantMetadata?: EditMetadata;
    firstEditMetadata?: FirstEditMetadata;
}

export class Evidence implements IEvidence {
    lineItems?: LineItem[] | undefined;

    constructor(data?: IEvidence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Evidence {
        data = typeof data === 'object' ? data : {};
        let result = new Evidence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEvidence {
    lineItems?: LineItem[] | undefined;
}

export class EvvComplianceGrouping implements IEvvComplianceGrouping {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    evvCompliantShifts?: number;
    totalShifts?: number;
    readonly compliancePercentage?: number;

    constructor(data?: IEvvComplianceGrouping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.evvCompliantShifts = _data["evvCompliantShifts"];
            this.totalShifts = _data["totalShifts"];
            (this as any).compliancePercentage = _data["compliancePercentage"];
        }
    }

    static fromJS(data: any): EvvComplianceGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new EvvComplianceGrouping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["evvCompliantShifts"] = this.evvCompliantShifts;
        data["totalShifts"] = this.totalShifts;
        data["compliancePercentage"] = this.compliancePercentage;
        return data;
    }
}

export interface IEvvComplianceGrouping {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    evvCompliantShifts?: number;
    totalShifts?: number;
    compliancePercentage?: number;
}

export class EvvComplianceRequest implements IEvvComplianceRequest {
    caregiverIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IEvvComplianceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): EvvComplianceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EvvComplianceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IEvvComplianceRequest {
    caregiverIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export class EvvComplianceResult implements IEvvComplianceResult {
    personId?: string | undefined;
    personType?: string | undefined;
    groupings?: EvvComplianceGrouping[] | undefined;
    readonly compliancePercentage?: number;

    constructor(data?: IEvvComplianceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personType = _data["personType"];
            if (Array.isArray(_data["groupings"])) {
                this.groupings = [] as any;
                for (let item of _data["groupings"])
                    this.groupings!.push(EvvComplianceGrouping.fromJS(item));
            }
            (this as any).compliancePercentage = _data["compliancePercentage"];
        }
    }

    static fromJS(data: any): EvvComplianceResult {
        data = typeof data === 'object' ? data : {};
        let result = new EvvComplianceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personType"] = this.personType;
        if (Array.isArray(this.groupings)) {
            data["groupings"] = [];
            for (let item of this.groupings)
                data["groupings"].push(item ? item.toJSON() : undefined as any);
        }
        data["compliancePercentage"] = this.compliancePercentage;
        return data;
    }
}

export interface IEvvComplianceResult {
    personId?: string | undefined;
    personType?: string | undefined;
    groupings?: EvvComplianceGrouping[] | undefined;
    compliancePercentage?: number;
}

export enum EvvComplianceStatus {
    None = "None",
    Yes = "Yes",
    NoDataMissing = "NoDataMissing",
    NoDataEdited = "NoDataEdited",
    LiveInExempt = "LiveInExempt",
    NA = "NA",
    ServiceCodeExempt = "ServiceCodeExempt",
}

export class Extraction implements IExtraction {
    sourceSystem?: string | undefined;
    version?: string | undefined;
    processedAt?: string;

    constructor(data?: IExtraction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSystem = _data["sourceSystem"];
            this.version = _data["version"];
            this.processedAt = _data["processedAt"];
        }
    }

    static fromJS(data: any): Extraction {
        data = typeof data === 'object' ? data : {};
        let result = new Extraction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSystem"] = this.sourceSystem;
        data["version"] = this.version;
        data["processedAt"] = this.processedAt;
        return data;
    }
}

export interface IExtraction {
    sourceSystem?: string | undefined;
    version?: string | undefined;
    processedAt?: string;
}

export class FetchShiftCommand implements IFetchShiftCommand {
    filterAdjustedShifts?: boolean;
    filterRequest?: FetchShiftRequestShiftFilterRequest[] | undefined;

    constructor(data?: IFetchShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterAdjustedShifts = _data["filterAdjustedShifts"];
            if (Array.isArray(_data["filterRequest"])) {
                this.filterRequest = [] as any;
                for (let item of _data["filterRequest"])
                    this.filterRequest!.push(FetchShiftRequestShiftFilterRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FetchShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterAdjustedShifts"] = this.filterAdjustedShifts;
        if (Array.isArray(this.filterRequest)) {
            data["filterRequest"] = [];
            for (let item of this.filterRequest)
                data["filterRequest"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFetchShiftCommand {
    filterAdjustedShifts?: boolean;
    filterRequest?: FetchShiftRequestShiftFilterRequest[] | undefined;
}

export class FetchShiftRequest implements IFetchShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;

    constructor(data?: IFetchShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.transactionId = _data["transactionId"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.caregiverId = _data["caregiverId"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.refTransactionId = _data["refTransactionId"];
            this.reasonId = _data["reasonId"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.adjustmentType = _data["adjustmentType"];
            this.onHold = _data["onHold"];
            this.neverBill = _data["neverBill"];
            this.neverPay = _data["neverPay"];
            this.employerId = _data["employerId"];
            if (Array.isArray(_data["ruleOverrides"])) {
                this.ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    this.ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.recordType = _data["recordType"];
            this.caregiverComments = _data["caregiverComments"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.destinationType = _data["destinationType"];
            this.caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.ivrNumberIn = _data["ivrNumberIn"];
            this.ivrNumberOut = _data["ivrNumberOut"];
            this.participantComments = _data["participantComments"];
            this.serviceCode = _data["serviceCode"];
            this.priority = _data["priority"];
            this.system = _data["system"];
            this.serviceDate = _data["serviceDate"];
            this.originalServiceDate = _data["originalServiceDate"];
            this.inTime = _data["inTime"];
            this.inTimeActual = _data["inTimeActual"];
            this.outTime = _data["outTime"];
            this.outTimeActual = _data["outTimeActual"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            this.isPsst = _data["isPsst"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.externalId = _data["externalId"];
            this.enrichmentData = _data["enrichmentData"];
            this.ruleStatus = _data["ruleStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.reasonDescription = _data["reasonDescription"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.concurrencyToken = _data["concurrencyToken"];
            this.vendorId = _data["vendorId"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billable = _data["billable"];
            this.payable = _data["payable"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            this.externalApprovalName = _data["externalApprovalName"];
            this.paidDate = _data["paidDate"];
            this.documentId = _data["documentId"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            if (Array.isArray(_data["requestLineItems"])) {
                this.requestLineItems = [] as any;
                for (let item of _data["requestLineItems"])
                    this.requestLineItems!.push(RequestLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineEntity.fromJS(item));
            }
            this.evidence = _data["evidence"] ? Evidence.fromJS(_data["evidence"]) : undefined as any;
        }
    }

    static fromJS(data: any): FetchShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["transactionId"] = this.transactionId;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["caregiverId"] = this.caregiverId;
        data["isSkipValidation"] = this.isSkipValidation;
        data["refTransactionId"] = this.refTransactionId;
        data["reasonId"] = this.reasonId;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["adjustmentType"] = this.adjustmentType;
        data["onHold"] = this.onHold;
        data["neverBill"] = this.neverBill;
        data["neverPay"] = this.neverPay;
        data["employerId"] = this.employerId;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["recordType"] = this.recordType;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantComments"] = this.participantComments;
        data["serviceCode"] = this.serviceCode;
        data["priority"] = this.priority;
        data["system"] = this.system;
        data["serviceDate"] = this.serviceDate;
        data["originalServiceDate"] = this.originalServiceDate;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["isPsst"] = this.isPsst;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["externalId"] = this.externalId;
        data["enrichmentData"] = this.enrichmentData;
        data["ruleStatus"] = this.ruleStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["reasonDescription"] = this.reasonDescription;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["concurrencyToken"] = this.concurrencyToken;
        data["vendorId"] = this.vendorId;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billable"] = this.billable;
        data["payable"] = this.payable;
        data["invoiceNumber"] = this.invoiceNumber;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["externalApprovalName"] = this.externalApprovalName;
        data["paidDate"] = this.paidDate;
        data["documentId"] = this.documentId;
        data["unit"] = this.unit;
        data["note"] = this.note;
        if (Array.isArray(this.requestLineItems)) {
            data["requestLineItems"] = [];
            for (let item of this.requestLineItems)
                data["requestLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["evidence"] = this.evidence ? this.evidence.toJSON() : undefined as any;
        return data;
    }
}

export interface IFetchShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
}

export class FetchShiftRequestShiftFilterRequest implements IFetchShiftRequestShiftFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    continuationToken?: string | undefined;
    entity?: FetchShiftRequest;
    sortProperty?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IFetchShiftRequestShiftFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.continuationToken = _data["continuationToken"];
            this.entity = _data["entity"] ? FetchShiftRequest.fromJS(_data["entity"]) : undefined as any;
            this.sortProperty = _data["sortProperty"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): FetchShiftRequestShiftFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftRequestShiftFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["continuationToken"] = this.continuationToken;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["sortProperty"] = this.sortProperty;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IFetchShiftRequestShiftFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    continuationToken?: string | undefined;
    entity?: FetchShiftRequest;
    sortProperty?: string | undefined;
    sortDirection?: string | undefined;
}

export class FetchShiftV2Command implements IFetchShiftV2Command {
    filterAdjustedShifts?: boolean;
    filterRequest?: FetchShiftV2RequestShiftFilterRequest[] | undefined;

    constructor(data?: IFetchShiftV2Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterAdjustedShifts = _data["filterAdjustedShifts"];
            if (Array.isArray(_data["filterRequest"])) {
                this.filterRequest = [] as any;
                for (let item of _data["filterRequest"])
                    this.filterRequest!.push(FetchShiftV2RequestShiftFilterRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FetchShiftV2Command {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftV2Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterAdjustedShifts"] = this.filterAdjustedShifts;
        if (Array.isArray(this.filterRequest)) {
            data["filterRequest"] = [];
            for (let item of this.filterRequest)
                data["filterRequest"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFetchShiftV2Command {
    filterAdjustedShifts?: boolean;
    filterRequest?: FetchShiftV2RequestShiftFilterRequest[] | undefined;
}

export class FetchShiftV2Request implements IFetchShiftV2Request {
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
    transactionStatuses?: number[] | undefined;
    evvComplianceStatuses?: EvvComplianceStatus[] | undefined;
    documentTypes?: string[] | undefined;
    documentType?: string | undefined;

    constructor(data?: IFetchShiftV2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.caregiverId = _data["caregiverId"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.refTransactionId = _data["refTransactionId"];
            this.reasonId = _data["reasonId"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.adjustmentType = _data["adjustmentType"];
            this.onHold = _data["onHold"];
            this.neverBill = _data["neverBill"];
            this.neverPay = _data["neverPay"];
            this.employerId = _data["employerId"];
            if (Array.isArray(_data["ruleOverrides"])) {
                this.ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    this.ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.recordType = _data["recordType"];
            this.caregiverComments = _data["caregiverComments"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.destinationType = _data["destinationType"];
            this.caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.ivrNumberIn = _data["ivrNumberIn"];
            this.ivrNumberOut = _data["ivrNumberOut"];
            this.participantComments = _data["participantComments"];
            this.serviceCode = _data["serviceCode"];
            this.priority = _data["priority"];
            this.system = _data["system"];
            this.serviceDate = _data["serviceDate"];
            this.originalServiceDate = _data["originalServiceDate"];
            this.inTime = _data["inTime"];
            this.inTimeActual = _data["inTimeActual"];
            this.outTime = _data["outTime"];
            this.outTimeActual = _data["outTimeActual"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            this.isPsst = _data["isPsst"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.externalId = _data["externalId"];
            this.enrichmentData = _data["enrichmentData"];
            this.ruleStatus = _data["ruleStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.reasonDescription = _data["reasonDescription"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.concurrencyToken = _data["concurrencyToken"];
            this.vendorId = _data["vendorId"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billable = _data["billable"];
            this.payable = _data["payable"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            this.externalApprovalName = _data["externalApprovalName"];
            this.paidDate = _data["paidDate"];
            this.documentId = _data["documentId"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            if (Array.isArray(_data["requestLineItems"])) {
                this.requestLineItems = [] as any;
                for (let item of _data["requestLineItems"])
                    this.requestLineItems!.push(RequestLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineEntity.fromJS(item));
            }
            this.evidence = _data["evidence"] ? Evidence.fromJS(_data["evidence"]) : undefined as any;
            if (Array.isArray(_data["transactionStatuses"])) {
                this.transactionStatuses = [] as any;
                for (let item of _data["transactionStatuses"])
                    this.transactionStatuses!.push(item);
            }
            if (Array.isArray(_data["evvComplianceStatuses"])) {
                this.evvComplianceStatuses = [] as any;
                for (let item of _data["evvComplianceStatuses"])
                    this.evvComplianceStatuses!.push(item);
            }
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): FetchShiftV2Request {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftV2Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["caregiverId"] = this.caregiverId;
        data["isSkipValidation"] = this.isSkipValidation;
        data["refTransactionId"] = this.refTransactionId;
        data["reasonId"] = this.reasonId;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["adjustmentType"] = this.adjustmentType;
        data["onHold"] = this.onHold;
        data["neverBill"] = this.neverBill;
        data["neverPay"] = this.neverPay;
        data["employerId"] = this.employerId;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["recordType"] = this.recordType;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantComments"] = this.participantComments;
        data["serviceCode"] = this.serviceCode;
        data["priority"] = this.priority;
        data["system"] = this.system;
        data["serviceDate"] = this.serviceDate;
        data["originalServiceDate"] = this.originalServiceDate;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["isPsst"] = this.isPsst;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["externalId"] = this.externalId;
        data["enrichmentData"] = this.enrichmentData;
        data["ruleStatus"] = this.ruleStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["reasonDescription"] = this.reasonDescription;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["concurrencyToken"] = this.concurrencyToken;
        data["vendorId"] = this.vendorId;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billable"] = this.billable;
        data["payable"] = this.payable;
        data["invoiceNumber"] = this.invoiceNumber;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["externalApprovalName"] = this.externalApprovalName;
        data["paidDate"] = this.paidDate;
        data["documentId"] = this.documentId;
        data["unit"] = this.unit;
        data["note"] = this.note;
        if (Array.isArray(this.requestLineItems)) {
            data["requestLineItems"] = [];
            for (let item of this.requestLineItems)
                data["requestLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["evidence"] = this.evidence ? this.evidence.toJSON() : undefined as any;
        if (Array.isArray(this.transactionStatuses)) {
            data["transactionStatuses"] = [];
            for (let item of this.transactionStatuses)
                data["transactionStatuses"].push(item);
        }
        if (Array.isArray(this.evvComplianceStatuses)) {
            data["evvComplianceStatuses"] = [];
            for (let item of this.evvComplianceStatuses)
                data["evvComplianceStatuses"].push(item);
        }
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface IFetchShiftV2Request {
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
    transactionStatuses?: number[] | undefined;
    evvComplianceStatuses?: EvvComplianceStatus[] | undefined;
    documentTypes?: string[] | undefined;
    documentType?: string | undefined;
}

export class FetchShiftV2RequestShiftFilterRequest implements IFetchShiftV2RequestShiftFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    continuationToken?: string | undefined;
    entity?: FetchShiftV2Request;
    sortProperty?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IFetchShiftV2RequestShiftFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.continuationToken = _data["continuationToken"];
            this.entity = _data["entity"] ? FetchShiftV2Request.fromJS(_data["entity"]) : undefined as any;
            this.sortProperty = _data["sortProperty"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): FetchShiftV2RequestShiftFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FetchShiftV2RequestShiftFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["continuationToken"] = this.continuationToken;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["sortProperty"] = this.sortProperty;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IFetchShiftV2RequestShiftFilterRequest {
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    continuationToken?: string | undefined;
    entity?: FetchShiftV2Request;
    sortProperty?: string | undefined;
    sortDirection?: string | undefined;
}

export class FirstEditMetadata implements IFirstEditMetadata {
    editedByUserName?: string | undefined;
    editedByUserEmail?: string | undefined;
    editedOn?: string | undefined;
    propertyName?: string | undefined;

    constructor(data?: IFirstEditMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editedByUserName = _data["editedByUserName"];
            this.editedByUserEmail = _data["editedByUserEmail"];
            this.editedOn = _data["editedOn"];
            this.propertyName = _data["propertyName"];
        }
    }

    static fromJS(data: any): FirstEditMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new FirstEditMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editedByUserName"] = this.editedByUserName;
        data["editedByUserEmail"] = this.editedByUserEmail;
        data["editedOn"] = this.editedOn;
        data["propertyName"] = this.propertyName;
        return data;
    }
}

export interface IFirstEditMetadata {
    editedByUserName?: string | undefined;
    editedByUserEmail?: string | undefined;
    editedOn?: string | undefined;
    propertyName?: string | undefined;
}

export class FreeSaveShiftCommand implements IFreeSaveShiftCommand {
    readonly shiftRequests?: UpsertShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IFreeSaveShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(UpsertShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): FreeSaveShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FreeSaveShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IFreeSaveShiftCommand {
    shiftRequests?: UpsertShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class GetDocumentByUriCommand implements IGetDocumentByUriCommand {
    uri?: string | undefined;

    constructor(data?: IGetDocumentByUriCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): GetDocumentByUriCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentByUriCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        return data;
    }
}

export interface IGetDocumentByUriCommand {
    uri?: string | undefined;
}

export class GetShiftApprovalHistoryCommand implements IGetShiftApprovalHistoryCommand {
    readonly shiftRequests?: GetShiftApprovalHistoryRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IGetShiftApprovalHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(GetShiftApprovalHistoryRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): GetShiftApprovalHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftApprovalHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IGetShiftApprovalHistoryCommand {
    shiftRequests?: GetShiftApprovalHistoryRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class GetShiftApprovalHistoryRequest implements IGetShiftApprovalHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    readonly id?: string | undefined;

    constructor(data?: IGetShiftApprovalHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            (this as any).id = _data["id"];
        }
    }

    static fromJS(data: any): GetShiftApprovalHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftApprovalHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShiftApprovalHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    id?: string | undefined;
}

export class GetShiftEvvHistoryDetailsCommand implements IGetShiftEvvHistoryDetailsCommand {
    readonly shiftRequests?: GetShiftEvvHistoryDetailsRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IGetShiftEvvHistoryDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(GetShiftEvvHistoryDetailsRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): GetShiftEvvHistoryDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftEvvHistoryDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IGetShiftEvvHistoryDetailsCommand {
    shiftRequests?: GetShiftEvvHistoryDetailsRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class GetShiftEvvHistoryDetailsRequest implements IGetShiftEvvHistoryDetailsRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    readonly id?: string | undefined;

    constructor(data?: IGetShiftEvvHistoryDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            (this as any).id = _data["id"];
        }
    }

    static fromJS(data: any): GetShiftEvvHistoryDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftEvvHistoryDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShiftEvvHistoryDetailsRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    id?: string | undefined;
}

export class GetShiftEvvHistoryRequest implements IGetShiftEvvHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    readonly id?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    adjustmentReasonCode?: string | undefined;

    constructor(data?: IGetShiftEvvHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            (this as any).id = _data["id"];
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.serviceCode = _data["serviceCode"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
        }
    }

    static fromJS(data: any): GetShiftEvvHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftEvvHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["id"] = this.id;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["serviceCode"] = this.serviceCode;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        return data;
    }
}

export interface IGetShiftEvvHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    id?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    adjustmentReasonCode?: string | undefined;
}

export class GetShiftHistoryCommand implements IGetShiftHistoryCommand {
    shiftHistoryRequest?: GetShiftHistoryRequest;
    intent?: string | undefined;

    constructor(data?: IGetShiftHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftHistoryRequest = _data["shiftHistoryRequest"] ? GetShiftHistoryRequest.fromJS(_data["shiftHistoryRequest"]) : undefined as any;
            this.intent = _data["intent"];
        }
    }

    static fromJS(data: any): GetShiftHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftHistoryRequest"] = this.shiftHistoryRequest ? this.shiftHistoryRequest.toJSON() : undefined as any;
        data["intent"] = this.intent;
        return data;
    }
}

export interface IGetShiftHistoryCommand {
    shiftHistoryRequest?: GetShiftHistoryRequest;
    intent?: string | undefined;
}

export class GetShiftHistoryDetailsCommand implements IGetShiftHistoryDetailsCommand {
    readonly shiftRequests?: GetShiftHistoryDetailsRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IGetShiftHistoryDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(GetShiftHistoryDetailsRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): GetShiftHistoryDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftHistoryDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IGetShiftHistoryDetailsCommand {
    shiftRequests?: GetShiftHistoryDetailsRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class GetShiftHistoryDetailsRequest implements IGetShiftHistoryDetailsRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    readonly id?: string | undefined;

    constructor(data?: IGetShiftHistoryDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            (this as any).id = _data["id"];
        }
    }

    static fromJS(data: any): GetShiftHistoryDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftHistoryDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShiftHistoryDetailsRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    id?: string | undefined;
}

export class GetShiftHistoryRequest implements IGetShiftHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    readonly id?: string | undefined;

    constructor(data?: IGetShiftHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            (this as any).id = _data["id"];
        }
    }

    static fromJS(data: any): GetShiftHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShiftHistoryRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    id?: string | undefined;
}

export class Gps implements IGps {
    lat?: number;
    long?: number;

    constructor(data?: IGps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.long = _data["long"];
        }
    }

    static fromJS(data: any): Gps {
        data = typeof data === 'object' ? data : {};
        let result = new Gps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["long"] = this.long;
        return data;
    }
}

export interface IGps {
    lat?: number;
    long?: number;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class LineEntity implements ILineEntity {
    amount?: number | undefined;
    documentId?: string | undefined;

    constructor(data?: ILineEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): LineEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LineEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ILineEntity {
    amount?: number | undefined;
    documentId?: string | undefined;
}

export class LineItem implements ILineItem {
    documentId?: string | undefined;
    documentUri?: string | undefined;
    extraction?: Extraction;
    claim?: VendorClaim;
    extractedEvidence?: VendorExtractedEvidence;

    constructor(data?: ILineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentUri = _data["documentUri"];
            this.extraction = _data["extraction"] ? Extraction.fromJS(_data["extraction"]) : undefined as any;
            this.claim = _data["claim"] ? VendorClaim.fromJS(_data["claim"]) : undefined as any;
            this.extractedEvidence = _data["extractedEvidence"] ? VendorExtractedEvidence.fromJS(_data["extractedEvidence"]) : undefined as any;
        }
    }

    static fromJS(data: any): LineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentUri"] = this.documentUri;
        data["extraction"] = this.extraction ? this.extraction.toJSON() : undefined as any;
        data["claim"] = this.claim ? this.claim.toJSON() : undefined as any;
        data["extractedEvidence"] = this.extractedEvidence ? this.extractedEvidence.toJSON() : undefined as any;
        return data;
    }
}

export interface ILineItem {
    documentId?: string | undefined;
    documentUri?: string | undefined;
    extraction?: Extraction;
    claim?: VendorClaim;
    extractedEvidence?: VendorExtractedEvidence;
}

export class NeverToBePaidShiftCommand implements INeverToBePaidShiftCommand {
    readonly shiftRequests?: NeverToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: INeverToBePaidShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(NeverToBePaidShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): NeverToBePaidShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NeverToBePaidShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface INeverToBePaidShiftCommand {
    shiftRequests?: NeverToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class NeverToBePaidShiftRequest implements INeverToBePaidShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: INeverToBePaidShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): NeverToBePaidShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NeverToBePaidShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface INeverToBePaidShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class PartialUpdateShiftCommand implements IPartialUpdateShiftCommand {
    readonly shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IPartialUpdateShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): PartialUpdateShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PartialUpdateShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IPartialUpdateShiftCommand {
    shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ReadyToBePaidShiftCommand implements IReadyToBePaidShiftCommand {
    readonly shiftRequests?: ReadyToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IReadyToBePaidShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ReadyToBePaidShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): ReadyToBePaidShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToBePaidShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IReadyToBePaidShiftCommand {
    shiftRequests?: ReadyToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class ReadyToBePaidShiftRequest implements IReadyToBePaidShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: IReadyToBePaidShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): ReadyToBePaidShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToBePaidShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IReadyToBePaidShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class RejectShiftCommand implements IRejectShiftCommand {
    readonly shiftRequests?: RejectShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IRejectShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(RejectShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): RejectShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IRejectShiftCommand {
    shiftRequests?: RejectShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class RejectShiftRequest implements IRejectShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IRejectShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RejectShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRejectShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    reason?: string | undefined;
}

export class RemovalInProgressShiftCommand implements IRemovalInProgressShiftCommand {
    readonly shiftRequests?: RemovalInProgressShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IRemovalInProgressShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(RemovalInProgressShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): RemovalInProgressShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalInProgressShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IRemovalInProgressShiftCommand {
    shiftRequests?: RemovalInProgressShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class RemovalInProgressShiftRequest implements IRemovalInProgressShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: IRemovalInProgressShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): RemovalInProgressShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalInProgressShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IRemovalInProgressShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class RemoveShiftCommand implements IRemoveShiftCommand {
    readonly shiftRequests?: RemoveShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IRemoveShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(RemoveShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): RemoveShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IRemoveShiftCommand {
    shiftRequests?: RemoveShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class RemoveShiftRequest implements IRemoveShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: IRemoveShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): RemoveShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IRemoveShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class RequestLineItem implements IRequestLineItem {
    amount?: number;
    file?: string | undefined;

    constructor(data?: IRequestLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): RequestLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new RequestLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["file"] = this.file;
        return data;
    }
}

export interface IRequestLineItem {
    amount?: number;
    file?: string | undefined;
}

export class ResponseModel implements IResponseModel {
    readonly failedRequests?: string[] | undefined;
    readonly successfulRequests?: string[] | undefined;
    readonly isSuccess?: boolean;
    action?: Action;
    details?: { [key: string]: string[]; } | undefined;
    failedRequestIds?: string[] | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["failedRequests"])) {
                (this as any).failedRequests = [] as any;
                for (let item of _data["failedRequests"])
                    (this as any).failedRequests!.push(item);
            }
            if (Array.isArray(_data["successfulRequests"])) {
                (this as any).successfulRequests = [] as any;
                for (let item of _data["successfulRequests"])
                    (this as any).successfulRequests!.push(item);
            }
            (this as any).isSuccess = _data["isSuccess"];
            this.action = _data["action"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (this.details as any)![key] = _data["details"][key] !== undefined ? _data["details"][key] : [];
                }
            }
            if (Array.isArray(_data["failedRequestIds"])) {
                this.failedRequestIds = [] as any;
                for (let item of _data["failedRequestIds"])
                    this.failedRequestIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.failedRequests)) {
            data["failedRequests"] = [];
            for (let item of this.failedRequests)
                data["failedRequests"].push(item);
        }
        if (Array.isArray(this.successfulRequests)) {
            data["successfulRequests"] = [];
            for (let item of this.successfulRequests)
                data["successfulRequests"].push(item);
        }
        data["isSuccess"] = this.isSuccess;
        data["action"] = this.action;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (data["details"] as any)[key] = (this.details as any)[key];
            }
        }
        if (Array.isArray(this.failedRequestIds)) {
            data["failedRequestIds"] = [];
            for (let item of this.failedRequestIds)
                data["failedRequestIds"].push(item);
        }
        return data;
    }
}

export interface IResponseModel {
    failedRequests?: string[] | undefined;
    successfulRequests?: string[] | undefined;
    isSuccess?: boolean;
    action?: Action;
    details?: { [key: string]: string[]; } | undefined;
    failedRequestIds?: string[] | undefined;
}

export class ResubmitShiftCommand implements IResubmitShiftCommand {
    readonly shiftRequests?: ResubmitShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IResubmitShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ResubmitShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): ResubmitShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IResubmitShiftCommand {
    shiftRequests?: ResubmitShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class ResubmitShiftRequest implements IResubmitShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    oldParticipantId?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    overrides?: RuleOverride[] | undefined;
    utexData?: UtexData;
    participantCompanyCode?: string | undefined;
    isSkipValidation?: boolean;

    constructor(data?: IResubmitShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.oldParticipantId = _data["oldParticipantId"];
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(RuleOverride.fromJS(item));
            }
            this.utexData = _data["utexData"] ? UtexData.fromJS(_data["utexData"]) : undefined as any;
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.isSkipValidation = _data["isSkipValidation"];
        }
    }

    static fromJS(data: any): ResubmitShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["oldParticipantId"] = this.oldParticipantId;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate;
        data["units"] = this.units;
        data["miles"] = this.miles;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["utexData"] = this.utexData ? this.utexData.toJSON() : undefined as any;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["isSkipValidation"] = this.isSkipValidation;
        return data;
    }
}

export interface IResubmitShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    oldParticipantId?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    overrides?: RuleOverride[] | undefined;
    utexData?: UtexData;
    participantCompanyCode?: string | undefined;
    isSkipValidation?: boolean;
}

export class RevertToReadyToBePaidV1ShiftCommand implements IRevertToReadyToBePaidV1ShiftCommand {
    readonly shiftRequests?: ReadyToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IRevertToReadyToBePaidV1ShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ReadyToBePaidShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): RevertToReadyToBePaidV1ShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RevertToReadyToBePaidV1ShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IRevertToReadyToBePaidV1ShiftCommand {
    shiftRequests?: ReadyToBePaidShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class RuleOverride implements IRuleOverride {
    ruleId?: string | undefined;

    constructor(data?: IRuleOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["ruleId"];
        }
    }

    static fromJS(data: any): RuleOverride {
        data = typeof data === 'object' ? data : {};
        let result = new RuleOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        return data;
    }
}

export interface IRuleOverride {
    ruleId?: string | undefined;
}

export class SaveShiftCommand implements ISaveShiftCommand {
    readonly shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: ISaveShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): SaveShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface ISaveShiftCommand {
    shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class ShiftDomainModel implements IShiftDomainModel {
    propertyChangeMessages?: string[] | undefined;
    readonly id?: string | undefined;
    readonly transactionId?: string | undefined;
    intent?: string | undefined;
    transactionStatus?: number | undefined;
    readonly refTransactionId?: string | undefined;
    readonly reasonId?: string | undefined;
    readonly isPositive?: boolean | undefined;
    readonly isVoid?: boolean | undefined;
    readonly isVoidOnly?: boolean | undefined;
    readonly adjustmentType?: number | undefined;
    readonly onHold?: boolean | undefined;
    readonly neverBill?: boolean | undefined;
    readonly neverPay?: boolean | undefined;
    readonly employerId?: string | undefined;
    readonly vendorId?: string | undefined;
    readonly billUnits?: number | undefined;
    readonly payUnits?: number | undefined;
    readonly payRate?: number | undefined;
    readonly paidDate?: string | undefined;
    readonly billRate?: number | undefined;
    readonly billable?: boolean | undefined;
    readonly payable?: boolean | undefined;
    readonly invoiceNumber?: string | undefined;
    readonly ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    readonly recordType?: string | undefined;
    readonly caregiverComments?: string | undefined;
    readonly source?: string | undefined;
    readonly sourceType?: string | undefined;
    readonly destinationType?: string | undefined;
    readonly calculatedHours?: number | undefined;
    readonly caregiverId?: string | undefined;
    readonly caregiverCompanyCode?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    readonly evvComplianceStatusDisplay?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    readonly ivrNumberIn?: string | undefined;
    readonly ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    readonly participantCompanyCode?: string | undefined;
    readonly participantComments?: string | undefined;
    readonly isMalformed?: boolean | undefined;
    readonly documentType?: string | undefined;
    docTypeEnum?: DocType;
    readonly serviceCode?: string | undefined;
    readonly priority?: number | undefined;
    readonly system?: string | undefined;
    readonly serviceDate?: string | undefined;
    readonly originalServiceDate?: string | undefined;
    readonly inTime?: string | undefined;
    readonly inTimeActual?: string | undefined;
    readonly outTime?: string | undefined;
    readonly outTimeActual?: string | undefined;
    readonly adjustmentReasonCode?: string | undefined;
    readonly units?: number | undefined;
    readonly miles?: number | undefined;
    readonly isPsst?: boolean | undefined;
    readonly tasks?: string[] | undefined;
    readonly externalId?: string | undefined;
    enrichmentData?: any | undefined;
    readonly ruleStatus?: string | undefined;
    readonly reasonDescription?: string | undefined;
    readonly ruleErrorMessageIds?: string[] | undefined;
    readonly userFriendlyReasonDescription?: string | undefined;
    readonly isEdited?: boolean | undefined;
    readonly isStartLocationSameAsParticipant?: boolean | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    externalApprovalName?: string | undefined;
    concurrencyToken?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;

    constructor(data?: IShiftDomainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propertyChangeMessages"])) {
                this.propertyChangeMessages = [] as any;
                for (let item of _data["propertyChangeMessages"])
                    this.propertyChangeMessages!.push(item);
            }
            (this as any).id = _data["id"];
            (this as any).transactionId = _data["transactionId"];
            this.intent = _data["intent"];
            this.transactionStatus = _data["transactionStatus"];
            (this as any).refTransactionId = _data["refTransactionId"];
            (this as any).reasonId = _data["reasonId"];
            (this as any).isPositive = _data["isPositive"];
            (this as any).isVoid = _data["isVoid"];
            (this as any).isVoidOnly = _data["isVoidOnly"];
            (this as any).adjustmentType = _data["adjustmentType"];
            (this as any).onHold = _data["onHold"];
            (this as any).neverBill = _data["neverBill"];
            (this as any).neverPay = _data["neverPay"];
            (this as any).employerId = _data["employerId"];
            (this as any).vendorId = _data["vendorId"];
            (this as any).billUnits = _data["billUnits"];
            (this as any).payUnits = _data["payUnits"];
            (this as any).payRate = _data["payRate"];
            (this as any).paidDate = _data["paidDate"];
            (this as any).billRate = _data["billRate"];
            (this as any).billable = _data["billable"];
            (this as any).payable = _data["payable"];
            (this as any).invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["ruleOverrides"])) {
                (this as any).ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    (this as any).ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            (this as any).recordType = _data["recordType"];
            (this as any).caregiverComments = _data["caregiverComments"];
            (this as any).source = _data["source"];
            (this as any).sourceType = _data["sourceType"];
            (this as any).destinationType = _data["destinationType"];
            (this as any).calculatedHours = _data["calculatedHours"];
            (this as any).caregiverId = _data["caregiverId"];
            (this as any).caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            (this as any).evvComplianceStatusDisplay = _data["evvComplianceStatusDisplay"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            (this as any).ivrNumberIn = _data["ivrNumberIn"];
            (this as any).ivrNumberOut = _data["ivrNumberOut"];
            this.participantId = _data["participantId"];
            (this as any).participantCompanyCode = _data["participantCompanyCode"];
            (this as any).participantComments = _data["participantComments"];
            (this as any).isMalformed = _data["isMalformed"];
            (this as any).documentType = _data["documentType"];
            this.docTypeEnum = _data["docTypeEnum"];
            (this as any).serviceCode = _data["serviceCode"];
            (this as any).priority = _data["priority"];
            (this as any).system = _data["system"];
            (this as any).serviceDate = _data["serviceDate"];
            (this as any).originalServiceDate = _data["originalServiceDate"];
            (this as any).inTime = _data["inTime"];
            (this as any).inTimeActual = _data["inTimeActual"];
            (this as any).outTime = _data["outTime"];
            (this as any).outTimeActual = _data["outTimeActual"];
            (this as any).adjustmentReasonCode = _data["adjustmentReasonCode"];
            (this as any).units = _data["units"];
            (this as any).miles = _data["miles"];
            (this as any).isPsst = _data["isPsst"];
            if (Array.isArray(_data["tasks"])) {
                (this as any).tasks = [] as any;
                for (let item of _data["tasks"])
                    (this as any).tasks!.push(item);
            }
            (this as any).externalId = _data["externalId"];
            this.enrichmentData = _data["enrichmentData"];
            (this as any).ruleStatus = _data["ruleStatus"];
            (this as any).reasonDescription = _data["reasonDescription"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                (this as any).ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    (this as any).ruleErrorMessageIds!.push(item);
            }
            (this as any).userFriendlyReasonDescription = _data["userFriendlyReasonDescription"];
            (this as any).isEdited = _data["isEdited"];
            (this as any).isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.externalApprovalName = _data["externalApprovalName"];
            this.concurrencyToken = _data["concurrencyToken"];
            this.documentId = _data["documentId"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            if (Array.isArray(_data["requestLineItems"])) {
                this.requestLineItems = [] as any;
                for (let item of _data["requestLineItems"])
                    this.requestLineItems!.push(RequestLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineEntity.fromJS(item));
            }
            this.evidence = _data["evidence"] ? Evidence.fromJS(_data["evidence"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftDomainModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDomainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propertyChangeMessages)) {
            data["propertyChangeMessages"] = [];
            for (let item of this.propertyChangeMessages)
                data["propertyChangeMessages"].push(item);
        }
        data["id"] = this.id;
        data["transactionId"] = this.transactionId;
        data["intent"] = this.intent;
        data["transactionStatus"] = this.transactionStatus;
        data["refTransactionId"] = this.refTransactionId;
        data["reasonId"] = this.reasonId;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["adjustmentType"] = this.adjustmentType;
        data["onHold"] = this.onHold;
        data["neverBill"] = this.neverBill;
        data["neverPay"] = this.neverPay;
        data["employerId"] = this.employerId;
        data["vendorId"] = this.vendorId;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["paidDate"] = this.paidDate;
        data["billRate"] = this.billRate;
        data["billable"] = this.billable;
        data["payable"] = this.payable;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["recordType"] = this.recordType;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        data["calculatedHours"] = this.calculatedHours;
        data["caregiverId"] = this.caregiverId;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["evvComplianceStatusDisplay"] = this.evvComplianceStatusDisplay;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["participantComments"] = this.participantComments;
        data["isMalformed"] = this.isMalformed;
        data["documentType"] = this.documentType;
        data["docTypeEnum"] = this.docTypeEnum;
        data["serviceCode"] = this.serviceCode;
        data["priority"] = this.priority;
        data["system"] = this.system;
        data["serviceDate"] = this.serviceDate;
        data["originalServiceDate"] = this.originalServiceDate;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["isPsst"] = this.isPsst;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["externalId"] = this.externalId;
        data["enrichmentData"] = this.enrichmentData;
        data["ruleStatus"] = this.ruleStatus;
        data["reasonDescription"] = this.reasonDescription;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["userFriendlyReasonDescription"] = this.userFriendlyReasonDescription;
        data["isEdited"] = this.isEdited;
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["externalApprovalName"] = this.externalApprovalName;
        data["concurrencyToken"] = this.concurrencyToken;
        data["documentId"] = this.documentId;
        data["unit"] = this.unit;
        data["note"] = this.note;
        if (Array.isArray(this.requestLineItems)) {
            data["requestLineItems"] = [];
            for (let item of this.requestLineItems)
                data["requestLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["evidence"] = this.evidence ? this.evidence.toJSON() : undefined as any;
        return data;
    }
}

export interface IShiftDomainModel {
    propertyChangeMessages?: string[] | undefined;
    id?: string | undefined;
    transactionId?: string | undefined;
    intent?: string | undefined;
    transactionStatus?: number | undefined;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    paidDate?: string | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    calculatedHours?: number | undefined;
    caregiverId?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    evvComplianceStatusDisplay?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    participantComments?: string | undefined;
    isMalformed?: boolean | undefined;
    documentType?: string | undefined;
    docTypeEnum?: DocType;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    userFriendlyReasonDescription?: string | undefined;
    isEdited?: boolean | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
    userId?: string | undefined;
    userEmail?: string | undefined;
    externalApprovalName?: string | undefined;
    concurrencyToken?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
}

export class ShiftFilterResponse implements IShiftFilterResponse {
    readonly entities?: ShiftDomainModel[] | undefined;
    readonly continuationToken?: string | undefined;
    readonly pageSize?: number | undefined;
    readonly pageNumber?: number | undefined;

    constructor(data?: IShiftFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                (this as any).entities = [] as any;
                for (let item of _data["entities"])
                    (this as any).entities!.push(ShiftDomainModel.fromJS(item));
            }
            (this as any).continuationToken = _data["continuationToken"];
            (this as any).pageSize = _data["pageSize"];
            (this as any).pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): ShiftFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        data["continuationToken"] = this.continuationToken;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IShiftFilterResponse {
    entities?: ShiftDomainModel[] | undefined;
    continuationToken?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export class ShiftHistoryDetails implements IShiftHistoryDetails {
    shiftId?: string | undefined;
    shiftStatus?: string | undefined;
    statusDate?: string | undefined;
    byEmail?: string | undefined;
    byUserName?: string | undefined;
    additionalInfo?: string[] | undefined;

    constructor(data?: IShiftHistoryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.shiftStatus = _data["shiftStatus"];
            this.statusDate = _data["statusDate"];
            this.byEmail = _data["byEmail"];
            this.byUserName = _data["byUserName"];
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftHistoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHistoryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["shiftStatus"] = this.shiftStatus;
        data["statusDate"] = this.statusDate;
        data["byEmail"] = this.byEmail;
        data["byUserName"] = this.byUserName;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item);
        }
        return data;
    }
}

export interface IShiftHistoryDetails {
    shiftId?: string | undefined;
    shiftStatus?: string | undefined;
    statusDate?: string | undefined;
    byEmail?: string | undefined;
    byUserName?: string | undefined;
    additionalInfo?: string[] | undefined;
}

export class ShiftHistoryDetailsResponse implements IShiftHistoryDetailsResponse {
    readonly transactionId?: string | undefined;
    shiftHistoryDetails?: ShiftHistoryDetails[] | undefined;

    constructor(data?: IShiftHistoryDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).transactionId = _data["transactionId"];
            if (Array.isArray(_data["shiftHistoryDetails"])) {
                this.shiftHistoryDetails = [] as any;
                for (let item of _data["shiftHistoryDetails"])
                    this.shiftHistoryDetails!.push(ShiftHistoryDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftHistoryDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHistoryDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.shiftHistoryDetails)) {
            data["shiftHistoryDetails"] = [];
            for (let item of this.shiftHistoryDetails)
                data["shiftHistoryDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiftHistoryDetailsResponse {
    transactionId?: string | undefined;
    shiftHistoryDetails?: ShiftHistoryDetails[] | undefined;
}

export class ShiftHistoryDto implements IShiftHistoryDto {
    shiftId?: string | undefined;
    transactionStatus?: number | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    serviceCode?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    miles?: number | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjustmentType?: number | undefined;
    startAddress?: Address;
    endAddress?: Address;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    ruleStatus?: string | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    isDeleted?: boolean;
    refTransactionId?: string | undefined;
    vendorId?: string | undefined;
    billable?: boolean | undefined;
    billUnits?: number | undefined;
    billRate?: number | undefined;
    payable?: boolean | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    id?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    tasks?: string[] | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    actionType?: string | undefined;
    changedByEmail?: string | undefined;
    changedByUserName?: string | undefined;
    changedOn?: string | undefined;

    constructor(data?: IShiftHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.transactionStatus = _data["transactionStatus"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.serviceCode = _data["serviceCode"];
            this.inTime = _data["inTime"];
            this.inTimeActual = _data["inTimeActual"];
            this.outTime = _data["outTime"];
            this.outTimeActual = _data["outTimeActual"];
            this.miles = _data["miles"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.adjustmentType = _data["adjustmentType"];
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.caregiverComments = _data["caregiverComments"];
            this.source = _data["source"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.ivrNumberIn = _data["ivrNumberIn"];
            this.ivrNumberOut = _data["ivrNumberOut"];
            this.participantComments = _data["participantComments"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.ruleStatus = _data["ruleStatus"];
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.isDeleted = _data["isDeleted"];
            this.refTransactionId = _data["refTransactionId"];
            this.vendorId = _data["vendorId"];
            this.billable = _data["billable"];
            this.billUnits = _data["billUnits"];
            this.billRate = _data["billRate"];
            this.payable = _data["payable"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            this.paidDate = _data["paidDate"];
            this.documentId = _data["documentId"];
            this.id = _data["id"];
            if (Array.isArray(_data["ruleOverrides"])) {
                this.ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    this.ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.actionType = _data["actionType"];
            this.changedByEmail = _data["changedByEmail"];
            this.changedByUserName = _data["changedByUserName"];
            this.changedOn = _data["changedOn"];
        }
    }

    static fromJS(data: any): ShiftHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["transactionStatus"] = this.transactionStatus;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["serviceCode"] = this.serviceCode;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["miles"] = this.miles;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["adjustmentType"] = this.adjustmentType;
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantComments"] = this.participantComments;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["ruleStatus"] = this.ruleStatus;
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["isDeleted"] = this.isDeleted;
        data["refTransactionId"] = this.refTransactionId;
        data["vendorId"] = this.vendorId;
        data["billable"] = this.billable;
        data["billUnits"] = this.billUnits;
        data["billRate"] = this.billRate;
        data["payable"] = this.payable;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["invoiceNumber"] = this.invoiceNumber;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["paidDate"] = this.paidDate;
        data["documentId"] = this.documentId;
        data["id"] = this.id;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["actionType"] = this.actionType;
        data["changedByEmail"] = this.changedByEmail;
        data["changedByUserName"] = this.changedByUserName;
        data["changedOn"] = this.changedOn;
        return data;
    }
}

export interface IShiftHistoryDto {
    shiftId?: string | undefined;
    transactionStatus?: number | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    serviceCode?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    miles?: number | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjustmentType?: number | undefined;
    startAddress?: Address;
    endAddress?: Address;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantComments?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    ruleStatus?: string | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    isDeleted?: boolean;
    refTransactionId?: string | undefined;
    vendorId?: string | undefined;
    billable?: boolean | undefined;
    billUnits?: number | undefined;
    billRate?: number | undefined;
    payable?: boolean | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    id?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    tasks?: string[] | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    actionType?: string | undefined;
    changedByEmail?: string | undefined;
    changedByUserName?: string | undefined;
    changedOn?: string | undefined;
}

export class ShiftHistoryResponse implements IShiftHistoryResponse {
    shiftHistoryDtos?: ShiftHistoryDto[] | undefined;
    changedShiftProperties?: ChangedShiftProperty[] | undefined;

    constructor(data?: IShiftHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftHistoryDtos"])) {
                this.shiftHistoryDtos = [] as any;
                for (let item of _data["shiftHistoryDtos"])
                    this.shiftHistoryDtos!.push(ShiftHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["changedShiftProperties"])) {
                this.changedShiftProperties = [] as any;
                for (let item of _data["changedShiftProperties"])
                    this.changedShiftProperties!.push(ChangedShiftProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftHistoryDtos)) {
            data["shiftHistoryDtos"] = [];
            for (let item of this.shiftHistoryDtos)
                data["shiftHistoryDtos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.changedShiftProperties)) {
            data["changedShiftProperties"] = [];
            for (let item of this.changedShiftProperties)
                data["changedShiftProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiftHistoryResponse {
    shiftHistoryDtos?: ShiftHistoryDto[] | undefined;
    changedShiftProperties?: ChangedShiftProperty[] | undefined;
}

export class ShiftRequest implements IShiftRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    participantComments?: string | undefined;
    documentType?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    isSkipValidation?: boolean;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;

    constructor(data?: IShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.refTransactionId = _data["refTransactionId"];
            this.reasonId = _data["reasonId"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.adjustmentType = _data["adjustmentType"];
            this.onHold = _data["onHold"];
            this.neverBill = _data["neverBill"];
            this.neverPay = _data["neverPay"];
            this.employerId = _data["employerId"];
            if (Array.isArray(_data["ruleOverrides"])) {
                this.ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    this.ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.recordType = _data["recordType"];
            this.caregiverComments = _data["caregiverComments"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.destinationType = _data["destinationType"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.ivrNumberIn = _data["ivrNumberIn"];
            this.ivrNumberOut = _data["ivrNumberOut"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.participantComments = _data["participantComments"];
            this.documentType = _data["documentType"];
            this.serviceCode = _data["serviceCode"];
            this.priority = _data["priority"];
            this.system = _data["system"];
            this.serviceDate = _data["serviceDate"];
            this.originalServiceDate = _data["originalServiceDate"];
            this.inTime = _data["inTime"];
            this.inTimeActual = _data["inTimeActual"];
            this.outTime = _data["outTime"];
            this.outTimeActual = _data["outTimeActual"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            this.isPsst = _data["isPsst"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.externalId = _data["externalId"];
            this.enrichmentData = _data["enrichmentData"];
            this.ruleStatus = _data["ruleStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.reasonDescription = _data["reasonDescription"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.concurrencyToken = _data["concurrencyToken"];
            this.vendorId = _data["vendorId"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billable = _data["billable"];
            this.payable = _data["payable"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            this.externalApprovalName = _data["externalApprovalName"];
            this.paidDate = _data["paidDate"];
            this.documentId = _data["documentId"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            if (Array.isArray(_data["requestLineItems"])) {
                this.requestLineItems = [] as any;
                for (let item of _data["requestLineItems"])
                    this.requestLineItems!.push(RequestLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineEntity.fromJS(item));
            }
            this.evidence = _data["evidence"] ? Evidence.fromJS(_data["evidence"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["refTransactionId"] = this.refTransactionId;
        data["reasonId"] = this.reasonId;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["adjustmentType"] = this.adjustmentType;
        data["onHold"] = this.onHold;
        data["neverBill"] = this.neverBill;
        data["neverPay"] = this.neverPay;
        data["employerId"] = this.employerId;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["recordType"] = this.recordType;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        data["caregiverId"] = this.caregiverId;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["participantComments"] = this.participantComments;
        data["documentType"] = this.documentType;
        data["serviceCode"] = this.serviceCode;
        data["priority"] = this.priority;
        data["system"] = this.system;
        data["serviceDate"] = this.serviceDate;
        data["originalServiceDate"] = this.originalServiceDate;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["isPsst"] = this.isPsst;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["externalId"] = this.externalId;
        data["enrichmentData"] = this.enrichmentData;
        data["ruleStatus"] = this.ruleStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["isSkipValidation"] = this.isSkipValidation;
        data["reasonDescription"] = this.reasonDescription;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["concurrencyToken"] = this.concurrencyToken;
        data["vendorId"] = this.vendorId;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billable"] = this.billable;
        data["payable"] = this.payable;
        data["invoiceNumber"] = this.invoiceNumber;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["externalApprovalName"] = this.externalApprovalName;
        data["paidDate"] = this.paidDate;
        data["documentId"] = this.documentId;
        data["unit"] = this.unit;
        data["note"] = this.note;
        if (Array.isArray(this.requestLineItems)) {
            data["requestLineItems"] = [];
            for (let item of this.requestLineItems)
                data["requestLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["evidence"] = this.evidence ? this.evidence.toJSON() : undefined as any;
        return data;
    }
}

export interface IShiftRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    participantComments?: string | undefined;
    documentType?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    isSkipValidation?: boolean;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    readonly canSeek?: boolean;
    readonly canTimeout?: boolean;
    readonly length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).canRead = _data["canRead"];
            (this as any).canWrite = _data["canWrite"];
            (this as any).canSeek = _data["canSeek"];
            (this as any).canTimeout = _data["canTimeout"];
            (this as any).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class StringExtractedEvidenceItem implements IStringExtractedEvidenceItem {
    value?: string | undefined;
    confidence?: number;

    constructor(data?: IStringExtractedEvidenceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): StringExtractedEvidenceItem {
        data = typeof data === 'object' ? data : {};
        let result = new StringExtractedEvidenceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IStringExtractedEvidenceItem {
    value?: string | undefined;
    confidence?: number;
}

export class SubmitShiftCommand implements ISubmitShiftCommand {
    readonly shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: ISubmitShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(ShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): SubmitShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface ISubmitShiftCommand {
    shiftRequests?: ShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class SuspendShiftCommand implements ISuspendShiftCommand {
    readonly shiftRequests?: SuspendShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: ISuspendShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(SuspendShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): SuspendShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SuspendShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface ISuspendShiftCommand {
    shiftRequests?: SuspendShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class SuspendShiftRequest implements ISuspendShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: ISuspendShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): SuspendShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SuspendShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface ISuspendShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class TimesheetEntriesRequest implements ITimesheetEntriesRequest {
    ptpntId!: string;
    ptpntCmpyCode!: string;
    readonly ptnKey?: string | undefined;
    stDate?: string | undefined;
    endDate?: string | undefined;
    docType?: string | undefined;
    txId!: string;
    batchSize?: number | undefined;
    continuationToken?: string | undefined;
    svcCode?: string | undefined;
    docTypes?: string | undefined;
    data?: string | undefined;

    constructor(data?: ITimesheetEntriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ptpntId = _data["ptpntId"];
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            (this as any).ptnKey = _data["ptnKey"];
            this.stDate = _data["stDate"];
            this.endDate = _data["endDate"];
            this.docType = _data["docType"];
            this.txId = _data["txId"];
            this.batchSize = _data["batchSize"];
            this.continuationToken = _data["continuationToken"];
            this.svcCode = _data["svcCode"];
            this.docTypes = _data["docTypes"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): TimesheetEntriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEntriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ptpntId"] = this.ptpntId;
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["ptnKey"] = this.ptnKey;
        data["stDate"] = this.stDate;
        data["endDate"] = this.endDate;
        data["docType"] = this.docType;
        data["txId"] = this.txId;
        data["batchSize"] = this.batchSize;
        data["continuationToken"] = this.continuationToken;
        data["svcCode"] = this.svcCode;
        data["docTypes"] = this.docTypes;
        data["data"] = this.data;
        return data;
    }
}

export interface ITimesheetEntriesRequest {
    ptpntId: string;
    ptpntCmpyCode: string;
    ptnKey?: string | undefined;
    stDate?: string | undefined;
    endDate?: string | undefined;
    docType?: string | undefined;
    txId: string;
    batchSize?: number | undefined;
    continuationToken?: string | undefined;
    svcCode?: string | undefined;
    docTypes?: string | undefined;
    data?: string | undefined;
}

export class TimesheetEntriesResponse implements ITimesheetEntriesResponse {
    totalResults?: number;
    continuationToken?: string | undefined;
    errorMessages?: string[] | undefined;
    resultSet?: any | undefined;
    statusCode?: HttpStatusCode;

    constructor(data?: ITimesheetEntriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            this.continuationToken = _data["continuationToken"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.resultSet = _data["resultSet"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): TimesheetEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetEntriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        data["continuationToken"] = this.continuationToken;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["resultSet"] = this.resultSet;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ITimesheetEntriesResponse {
    totalResults?: number;
    continuationToken?: string | undefined;
    errorMessages?: string[] | undefined;
    resultSet?: any | undefined;
    statusCode?: HttpStatusCode;
}

export enum UnitMethod {
    UnitBased = "UnitBased",
    MarkUp = "MarkUp",
    BillOneUnit = "BillOneUnit",
    ExactCost = "ExactCost",
}

export class UpdateShiftCommand implements IUpdateShiftCommand {
    readonly shiftRequests?: UpdateShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IUpdateShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(UpdateShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): UpdateShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IUpdateShiftCommand {
    shiftRequests?: UpdateShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class UpdateShiftRequest implements IUpdateShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    caregiverComments?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    tasks?: string[] | undefined;
    serviceCode?: string | undefined;
    miles?: number | undefined;
    units?: number | undefined;
    isPsst?: boolean | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    adjustmentReasonCode?: string | undefined;
    startAddress?: Address;
    endAddress?: Address;
    source?: string | undefined;

    constructor(data?: IUpdateShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.documentType = _data["documentType"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.caregiverComments = _data["caregiverComments"];
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.serviceCode = _data["serviceCode"];
            this.miles = _data["miles"];
            this.units = _data["units"];
            this.isPsst = _data["isPsst"];
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): UpdateShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["documentType"] = this.documentType;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["caregiverComments"] = this.caregiverComments;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["serviceCode"] = this.serviceCode;
        data["miles"] = this.miles;
        data["units"] = this.units;
        data["isPsst"] = this.isPsst;
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["source"] = this.source;
        return data;
    }
}

export interface IUpdateShiftRequest {
    transactionId?: string | undefined;
    documentType?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    caregiverComments?: string | undefined;
    inTime?: string | undefined;
    outTime?: string | undefined;
    tasks?: string[] | undefined;
    serviceCode?: string | undefined;
    miles?: number | undefined;
    units?: number | undefined;
    isPsst?: boolean | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    adjustmentReasonCode?: string | undefined;
    startAddress?: Address;
    endAddress?: Address;
    source?: string | undefined;
}

export class UpsertShiftRequest implements IUpsertShiftRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    participantComments?: string | undefined;
    documentType?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    isSkipValidation?: boolean;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;

    constructor(data?: IUpsertShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.refTransactionId = _data["refTransactionId"];
            this.reasonId = _data["reasonId"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.adjustmentType = _data["adjustmentType"];
            this.onHold = _data["onHold"];
            this.neverBill = _data["neverBill"];
            this.neverPay = _data["neverPay"];
            this.employerId = _data["employerId"];
            if (Array.isArray(_data["ruleOverrides"])) {
                this.ruleOverrides = [] as any;
                for (let item of _data["ruleOverrides"])
                    this.ruleOverrides!.push(RuleOverride.fromJS(item));
            }
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : undefined as any;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : undefined as any;
            this.recordType = _data["recordType"];
            this.caregiverComments = _data["caregiverComments"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.destinationType = _data["destinationType"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : undefined as any;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : undefined as any;
            this.ivrNumberIn = _data["ivrNumberIn"];
            this.ivrNumberOut = _data["ivrNumberOut"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.participantComments = _data["participantComments"];
            this.documentType = _data["documentType"];
            this.serviceCode = _data["serviceCode"];
            this.priority = _data["priority"];
            this.system = _data["system"];
            this.serviceDate = _data["serviceDate"];
            this.originalServiceDate = _data["originalServiceDate"];
            this.inTime = _data["inTime"];
            this.inTimeActual = _data["inTimeActual"];
            this.outTime = _data["outTime"];
            this.outTimeActual = _data["outTimeActual"];
            this.adjustmentReasonCode = _data["adjustmentReasonCode"];
            this.units = _data["units"];
            this.miles = _data["miles"];
            this.isPsst = _data["isPsst"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.externalId = _data["externalId"];
            this.enrichmentData = _data["enrichmentData"];
            this.ruleStatus = _data["ruleStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.reasonDescription = _data["reasonDescription"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.isStartLocationSameAsParticipant = _data["isStartLocationSameAsParticipant"];
            this.concurrencyToken = _data["concurrencyToken"];
            this.vendorId = _data["vendorId"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billable = _data["billable"];
            this.payable = _data["payable"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.evvComplianceStatus = _data["evvComplianceStatus"];
            this.externalApprovalName = _data["externalApprovalName"];
            this.paidDate = _data["paidDate"];
            this.documentId = _data["documentId"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            if (Array.isArray(_data["requestLineItems"])) {
                this.requestLineItems = [] as any;
                for (let item of _data["requestLineItems"])
                    this.requestLineItems!.push(RequestLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineEntity.fromJS(item));
            }
            this.evidence = _data["evidence"] ? Evidence.fromJS(_data["evidence"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpsertShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["refTransactionId"] = this.refTransactionId;
        data["reasonId"] = this.reasonId;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["adjustmentType"] = this.adjustmentType;
        data["onHold"] = this.onHold;
        data["neverBill"] = this.neverBill;
        data["neverPay"] = this.neverPay;
        data["employerId"] = this.employerId;
        if (Array.isArray(this.ruleOverrides)) {
            data["ruleOverrides"] = [];
            for (let item of this.ruleOverrides)
                data["ruleOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : undefined as any;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : undefined as any;
        data["recordType"] = this.recordType;
        data["caregiverComments"] = this.caregiverComments;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        data["caregiverId"] = this.caregiverId;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : undefined as any;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : undefined as any;
        data["ivrNumberIn"] = this.ivrNumberIn;
        data["ivrNumberOut"] = this.ivrNumberOut;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["participantComments"] = this.participantComments;
        data["documentType"] = this.documentType;
        data["serviceCode"] = this.serviceCode;
        data["priority"] = this.priority;
        data["system"] = this.system;
        data["serviceDate"] = this.serviceDate;
        data["originalServiceDate"] = this.originalServiceDate;
        data["inTime"] = this.inTime;
        data["inTimeActual"] = this.inTimeActual;
        data["outTime"] = this.outTime;
        data["outTimeActual"] = this.outTimeActual;
        data["adjustmentReasonCode"] = this.adjustmentReasonCode;
        data["units"] = this.units;
        data["miles"] = this.miles;
        data["isPsst"] = this.isPsst;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["externalId"] = this.externalId;
        data["enrichmentData"] = this.enrichmentData;
        data["ruleStatus"] = this.ruleStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["isSkipValidation"] = this.isSkipValidation;
        data["reasonDescription"] = this.reasonDescription;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["isStartLocationSameAsParticipant"] = this.isStartLocationSameAsParticipant;
        data["concurrencyToken"] = this.concurrencyToken;
        data["vendorId"] = this.vendorId;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billable"] = this.billable;
        data["payable"] = this.payable;
        data["invoiceNumber"] = this.invoiceNumber;
        data["evvComplianceStatus"] = this.evvComplianceStatus;
        data["externalApprovalName"] = this.externalApprovalName;
        data["paidDate"] = this.paidDate;
        data["documentId"] = this.documentId;
        data["unit"] = this.unit;
        data["note"] = this.note;
        if (Array.isArray(this.requestLineItems)) {
            data["requestLineItems"] = [];
            for (let item of this.requestLineItems)
                data["requestLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["evidence"] = this.evidence ? this.evidence.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpsertShiftRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    reasonId?: string | undefined;
    isPositive?: boolean | undefined;
    isVoid?: boolean | undefined;
    isVoidOnly?: boolean | undefined;
    adjustmentType?: number | undefined;
    onHold?: boolean | undefined;
    neverBill?: boolean | undefined;
    neverPay?: boolean | undefined;
    employerId?: string | undefined;
    ruleOverrides?: RuleOverride[] | undefined;
    startAddress?: Address;
    endAddress?: Address;
    recordType?: string | undefined;
    caregiverComments?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destinationType?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNumberIn?: string | undefined;
    ivrNumberOut?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    participantComments?: string | undefined;
    documentType?: string | undefined;
    serviceCode?: string | undefined;
    priority?: number | undefined;
    system?: string | undefined;
    serviceDate?: string | undefined;
    originalServiceDate?: string | undefined;
    inTime?: string | undefined;
    inTimeActual?: string | undefined;
    outTime?: string | undefined;
    outTimeActual?: string | undefined;
    adjustmentReasonCode?: string | undefined;
    units?: number | undefined;
    miles?: number | undefined;
    isPsst?: boolean | undefined;
    tasks?: string[] | undefined;
    externalId?: string | undefined;
    enrichmentData?: any | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: number | undefined;
    isSkipValidation?: boolean;
    reasonDescription?: string | undefined;
    ruleErrorMessageIds?: string[] | undefined;
    isStartLocationSameAsParticipant?: boolean | undefined;
    concurrencyToken?: string | undefined;
    vendorId?: string | undefined;
    billUnits?: number | undefined;
    payUnits?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    billable?: boolean | undefined;
    payable?: boolean | undefined;
    invoiceNumber?: string | undefined;
    evvComplianceStatus?: EvvComplianceStatus;
    externalApprovalName?: string | undefined;
    paidDate?: string | undefined;
    documentId?: number | undefined;
    unit?: number | undefined;
    note?: string | undefined;
    requestLineItems?: RequestLineItem[] | undefined;
    lines?: LineEntity[] | undefined;
    evidence?: Evidence;
}

export class UtexData implements IUtexData {
    tcn?: string | undefined;
    utexId?: number;
    reasonId?: number;
    reasonDescription?: string | undefined;

    constructor(data?: IUtexData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.utexId = _data["utexId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
        }
    }

    static fromJS(data: any): UtexData {
        data = typeof data === 'object' ? data : {};
        let result = new UtexData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["utexId"] = this.utexId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        return data;
    }
}

export interface IUtexData {
    tcn?: string | undefined;
    utexId?: number;
    reasonId?: number;
    reasonDescription?: string | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class VendorClaim implements IVendorClaim {
    amount?: number;

    constructor(data?: IVendorClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): VendorClaim {
        data = typeof data === 'object' ? data : {};
        let result = new VendorClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }
}

export interface IVendorClaim {
    amount?: number;
}

export class VendorExtractedEvidence implements IVendorExtractedEvidence {
    amount?: DecimalExtractedEvidenceItem;
    providerName?: StringExtractedEvidenceItem;
    serviceDate?: DateTimeExtractedEvidenceItem;

    constructor(data?: IVendorExtractedEvidence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] ? DecimalExtractedEvidenceItem.fromJS(_data["amount"]) : undefined as any;
            this.providerName = _data["providerName"] ? StringExtractedEvidenceItem.fromJS(_data["providerName"]) : undefined as any;
            this.serviceDate = _data["serviceDate"] ? DateTimeExtractedEvidenceItem.fromJS(_data["serviceDate"]) : undefined as any;
        }
    }

    static fromJS(data: any): VendorExtractedEvidence {
        data = typeof data === 'object' ? data : {};
        let result = new VendorExtractedEvidence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount ? this.amount.toJSON() : undefined as any;
        data["providerName"] = this.providerName ? this.providerName.toJSON() : undefined as any;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toJSON() : undefined as any;
        return data;
    }
}

export interface IVendorExtractedEvidence {
    amount?: DecimalExtractedEvidenceItem;
    providerName?: StringExtractedEvidenceItem;
    serviceDate?: DateTimeExtractedEvidenceItem;
}

export class VoidShiftCommand implements IVoidShiftCommand {
    readonly shiftRequests?: VoidShiftRequest[] | undefined;
    intent?: string | undefined;
    readonly commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;

    constructor(data?: IVoidShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftRequests"])) {
                (this as any).shiftRequests = [] as any;
                for (let item of _data["shiftRequests"])
                    (this as any).shiftRequests!.push(VoidShiftRequest.fromJS(item));
            }
            this.intent = _data["intent"];
            (this as any).commandIdentifier = _data["commandIdentifier"];
            this.outboxMessageId = _data["outboxMessageId"];
        }
    }

    static fromJS(data: any): VoidShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VoidShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftRequests)) {
            data["shiftRequests"] = [];
            for (let item of this.shiftRequests)
                data["shiftRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["intent"] = this.intent;
        data["commandIdentifier"] = this.commandIdentifier;
        data["outboxMessageId"] = this.outboxMessageId;
        return data;
    }
}

export interface IVoidShiftCommand {
    shiftRequests?: VoidShiftRequest[] | undefined;
    intent?: string | undefined;
    commandIdentifier?: string | undefined;
    outboxMessageId?: number | undefined;
}

export class VoidShiftRequest implements IVoidShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    serviceCode?: string | undefined;

    constructor(data?: IVoidShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.transactionId = _data["transactionId"];
            this.participantId = _data["participantId"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.caregiverId = _data["caregiverId"];
            this.isSkipValidation = _data["isSkipValidation"];
            this.serviceCode = _data["serviceCode"];
        }
    }

    static fromJS(data: any): VoidShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VoidShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["transactionId"] = this.transactionId;
        data["participantId"] = this.participantId;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["caregiverId"] = this.caregiverId;
        data["isSkipValidation"] = this.isSkipValidation;
        data["serviceCode"] = this.serviceCode;
        return data;
    }
}

export interface IVoidShiftRequest {
    documentType?: string | undefined;
    transactionId?: string | undefined;
    participantId?: string | undefined;
    participantCompanyCode?: string | undefined;
    caregiverId?: string | undefined;
    isSkipValidation?: boolean;
    serviceCode?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}